import InfoPopUpIcon from '@Components/Icons/InfoPopUpIcon';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';

type DisclosureGuidelineModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  note?: string | React.ReactNode;
  description: string | React.ReactNode;
} & DialogProps;

const DisclosureGuidelineModal = ({
  open,
  onClose,
  title,
  note,
  description,
  ...props
}: DisclosureGuidelineModalProps) => {
  const theme = useTheme();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth {...props}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <InfoPopUpIcon fontSize="large" color={'primary'} />
        <Typography fontSize="14" fontWeight="bold">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          paddingLeft: '8%',
          paddingRight: '8%',
          borderTop: 'none',
        }}
      >
        <Tabs sx={{ borderBottom: 4, borderColor: theme.palette.primary.main }}>
          <Tab
            sx={{
              backgroundImage: `linear-gradient(to top, ${theme.palette.primary.main}, ${theme.palette.yellow[500]})`,
              backgroundPosition: 'bottom',
              backgroundSize: '100%',
              borderTopLeftRadius: '4px',
              borderTopRightRadius: '4px',
              color: 'black',
            }}
            label="แบบ Corporate Value Up"
          />
        </Tabs>
        <Box
          component="section"
          p={1.5}
          border={'1px solid rgba(169, 169, 169, 0.3)'}
          borderRadius={0.5}
        >
          {typeof description === 'string' ? (
            <Typography mt={2}>{description}</Typography>
          ) : (
            description
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="inherit">
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DisclosureGuidelineModal;
